import { createStyles, makeStyles } from '@material-ui/core/styles';
import { theme } from '../Theme';
import { getOpacityColor, getTextColor } from '../utils/constants';
import { isCustomColor } from './index';

var createChipColor = function (color) {
  return {
    backgroundColor: color,
    color: getTextColor(color),
    '&$outlined': {
      backgroundColor: 'transparent',
      color: color,
      border: "1px solid " + color,
      '& .MuiChip-deleteIcon': {
        color: getOpacityColor(color)(0.5)
      },
      '& .MuiChip-avatar': {
        color: color
      }
    },
    '& .MuiChip-avatar': {
      color: getTextColor(color)
    },
    '& .MuiChip-deleteIcon': {
      color: 'rgba(255, 255, 255, 0.5)'
    }
  };
};

var useStyles = makeStyles(function () {
  var _theme$colors = theme.colors,
      primaryColor = _theme$colors.primaryColor,
      successColor = _theme$colors.successColor,
      dangerColor = _theme$colors.dangerColor,
      infoColor = _theme$colors.infoColor,
      warningColor = _theme$colors.warningColor,
      roseColor = _theme$colors.roseColor;
  return createStyles({
    root: {
      '& .MuiChip-deleteIcon': {
        width: 28,
        height: 28,
        marginRight: 2
      },
      '& .MuiChip-deleteIconSmall': {
        width: 20,
        height: 20,
        marginRight: 2
      }
    },
    primary: createChipColor(primaryColor),
    info: createChipColor(infoColor),
    success: createChipColor(successColor),
    warning: createChipColor(warningColor),
    danger: createChipColor(dangerColor),
    rose: createChipColor(roseColor),
    outlined: {
      color: '#616161'
    },
    square: {
      borderRadius: 5
    },
    customColor: function customColor(props) {
      return createChipColor(isCustomColor((props == null ? void 0 : props.color) || '') ? props.color || '#999999' : '#999999');
    }
  });
});
export default useStyles;